/** Shared lazy loaders so menu prefetch and vue-router hit the same chunks. */

export const asyncViews = {
  market: () => import('../views/market/Market.vue'),
  trading: () => import('../views/trading/Trading.vue'),
  loan: () => import('../views/loan/Loan.vue'),
  nfts: () => import('../views/nfts/Nfts.vue'),
  profile: () => import('../views/profile/Profile.vue'),
  orders: () => import('../views/orders/Orders.vue'),
  cruuency: () => import('../views/cruuency/Cruuency.vue'),
  deposit: () => import('../views/profile/deposit/index.vue'),
  withdraw: () => import('../views/profile/withdraw/index.vue'),
  moneyLog: () => import('../views/profile/moneyLog/index.vue'),
  invite: () => import('../views/profile/invite/index.vue'),
  notification: () => import('../views/profile/notification/index.vue'),
  identity: () => import('../views/profile/identity/index.vue'),
  register: () => import('../views/pass/register/index.vue'),
  login: () => import('../views/pass/login/index.vue'),
  reset: () => import('../views/pass/reset/index.vue'),
  empty: () => import('../views/pass/empty/index.vue'),
  lendingPools: () => import('../views/lending/LendingPools.vue'),
  lendingPoolDetail: () => import('../views/lending/LendingPoolDetail.vue'),
  lendingContent: () => import('../views/lending/LendingContent.vue'),
  lendingAssets: () => import('../views/lending/LendingAssets.vue'),
  Introduction: () => import('../views/Introduction/index.vue')
}

/** High-traffic pages first so idle / menu prefetch spends bandwidth on likely next hops. */
export const MENU_PREFETCH_NAMES = [
  'market',
  'trading',
  'cruuency',
  'profile',
  'orders',
  'deposit',
  'withdraw',
  'moneyLog',
  'nfts',
  'lendingPools',
  'loan',
  'identity',
  'invite',
  'notification',
  'lendingContent'
]

let menuPrefetchStarted = false
let idlePrefetchScheduled = false

export function prefetchRoute(name) {
  const load = asyncViews[name]
  return load ? load() : Promise.resolve()
}

export function prefetchMenuRoutes({ concurrency = 2 } = {}) {
  if (menuPrefetchStarted) return Promise.resolve()
  menuPrefetchStarted = true
  const names = MENU_PREFETCH_NAMES
  let index = 0
  const worker = () => {
    if (index >= names.length) return Promise.resolve()
    const name = names[index++]
    return prefetchRoute(name)
      .catch(() => {})
      .then(worker)
  }
  const count = Math.max(1, Math.min(concurrency, 2))
  const workers = []
  for (let i = 0; i < count; i++) workers.push(worker())
  return Promise.all(workers)
}

function isConstrainedNetwork() {
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection
  if (!conn) return false
  if (conn.saveData) return true
  return conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g'
}

/** After first paint: download other page chunks in the background. Skip on 2G / data saver. */
export function startIdlePrefetch() {
  if (idlePrefetchScheduled || menuPrefetchStarted || isConstrainedNetwork()) return
  idlePrefetchScheduled = true

  const kick = () => {
    prefetchMenuRoutes({ concurrency: 1 })
  }

  const afterLoad = () => {
    const run = () => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(kick, { timeout: 3000 })
      } else {
        setTimeout(kick, 1500)
      }
    }
    setTimeout(run, 800)
  }

  if (document.readyState === 'complete') {
    afterLoad()
  } else {
    window.addEventListener('load', afterLoad, { once: true })
  }
}
